import { useEffect, useMemo, useState } from 'react';

// 管理コンソール／開発者ポータル向けの簡易ページング（前へ／次へのみ）。
// components/Pagination.tsx（Animations 一覧向けのページ番号付き UI）とは別物。
// 元々 AdminConsole.tsx にローカル定義されていたものを、DevPortal.tsx と共通化するために移設した。

/** 一覧に対するページ分割の状態を管理する共通フック。 */
export function usePagination<T>(items: T[], pageSize: number) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));

  useEffect(() => {
    if (page > totalPages) {
      setPage(1);
    }
  }, [page, totalPages]);

  const pageItems = useMemo(
    () => items.slice((page - 1) * pageSize, page * pageSize),
    [items, page, pageSize],
  );

  return { page, setPage, totalPages, pageItems };
}

export function Pagination({
  page,
  totalPages,
  onChange,
  disableNext,
}: {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  disableNext?: boolean;
}) {
  if (totalPages <= 1) return null;

  return (
    <nav className="pagination">
      <button className="btn" disabled={page <= 1} onClick={() => onChange(page - 1)}>
        前へ
      </button>
      <span className="pagination__info">
        {page} / {totalPages} ページ
      </span>
      <button
        className="btn"
        disabled={page >= totalPages || disableNext}
        onClick={() => onChange(page + 1)}
      >
        次へ
      </button>
    </nav>
  );
}
